import en from './en';
var Locales = {
    en: en,
    ru: function () { return import('./ru').then(function (data) { return data["default"]; }); }
};
export default Locales;
